import React from 'react';
import './Shukkin.css';
import illustTaskMng from "../image/illust_taskmng.png";
import illustAsk from "../image/illust_ask.png";
import illustWhoWorks from "../image/illust_whoworks.png";
import iconGraph from "../image/icon_graph.png";
import iconActiveMember from "../image/icon_activemember.png";
import iconTimer from "../image/icon_timer.png";
import shotMain from "../image/Shot_main.png";
import shukkinDark from "../image/Shukkin_dark.png";
import Step1 from "../image/step1.svg";
import Step2 from "../image/step2.svg";
import Step3 from "../image/step3.svg";



const Shukkin = () => {
  return (
    <>
    <div className="ShukkinMain">

      <div className="ShukkinTitle">
        <p>SERVICE</p>
        <p>リモートチーム活動記録管理サポートツール</p>
        <img src={shukkinDark} alt ="シュッキンのロゴ"/>
      </div>
      
      <div className="ShukkinContent">
        
        <div className="ShukkinShot">
          <img src={shotMain} alt ="シュッキンのアプリ"/>
        </div>

        <div className="ShukkinCharacteristics">
          <h3>３つの特徴</h3>
          <div class = "c1">
            <p>活動を記録</p>
            <img src={iconTimer} alt ="シュッキンのアプリ"/>
          </div> 
          <div class = "c2">
            <p>今活動中のメンバーがわかる</p>
            <img src={iconActiveMember} alt ="シュッキンのアプリ"/>
          </div> 
          <div class = "c3">
            <p>チームメンバーの活動量を可視化</p>
            <img src={iconGraph} alt ="シュッキンのアプリ"/>
          </div> 
        </div>
        </div>

        <div className="ShukkinTarget">
          <p>チームでリモート活動をする</p>
          <div className="target-bubbles">
            <div className="bubble">課外活動</div>
            <div className="bubble">副業</div>
            <div className="bubble">プロジェクト</div>
           </div>
          <p className="target-question">こんなお悩みはありませんか・・・？</p>

        </div>

        <div className="ShukkinNayami">
          <div class = "n1">
              <p>今からタスクしようかな、<br />誰かやってるならzoom繋ごうかな？</p>
              <img src={illustWhoWorks} alt ="シュッキンの画像１"/>
            </div> 
            <div class = "n2">
              <p>ちょっとこの部分相談したいな、<br />誰ならすぐ返してくれるかな？</p>
              <img src={illustAsk} alt ="シュッキンの画像２"/>
            </div> 
            <div class = "n3">
              <p>分担したはいいけど、<br />みんなどれくらい活動してるんだろう？</p>
              <img src={illustTaskMng} alt ="シュッキンの画像３"/>
            </div> 
        </div>

    </div>


    <div className="ShukkinHowToUse">
        <h4>シュッキンがあれば！</h4>

        <div className="ShukkinHowToUseStep1">
          <div className="ShukkinHowToUseStepImg">
            <img src={Step1} alt ="シュッキンのステップ１"/>
          </div>
          <div className="ShukkinHowToUseStepText">
            <p className="step-label">STEP</p>
            <h1 className="step-number">01</h1>
            <h2 className="step-title">作業開始時に活動を記録</h2>
            <p className="step-description">
              個人での作業やチーム内部でのミーティングなど、<br />
              活動開始時にワンタップで記録できます。記録すると、<br />
              チームメンバーにアプリから通知が！<br />
              記録を忘れてしまっても、後から編集可能です。
            </p>
            </div>
          </div>

        <div className="ShukkinHowToUseStep2">
          <div className="ShukkinHowToUseStepText">
            <p className="step-label">STEP</p>
            <h1 className="step-number">02</h1>
            <h2 className="step-title">アクティブメンバーを確認して<br />効率よくリモート作業</h2>
            <p className="step-description">
              分散環境下でのチーム活動でよくあるのが<br />
              「zoomで繋いでおくだけでやる気が出る！」<br />
              「ちょっとわからないことがあった時に気軽に聞きたい！」<br />
              という状況。でも誰が「今」やっているのか分からない…<br />
              そんな時シュッキンを開けば、誰が活動中なのか<br />
              一目でわかります。
            </p>
          </div>
          <div className="ShukkinHowToUseStepImg">
            <img src={Step2} alt ="シュッキンのステップ２"/>
              </div>
          </div>

        <div className="ShukkinHowToUseStep3">
          <div className="ShukkinHowToUseStepImg">
            <img src={Step3} alt ="シュッキンのステップ３"/>
          </div>
          <div className="ShukkinHowToUseStepText">
            <p className="step-label">STEP</p>
            <h1 className="step-number">03</h1>
            <h2 className="step-title">チームや個人の活動の記録を<br />可視化・蓄積し、活動にフィードバック</h2>
            <p className="step-description">
            個人ごと、チーム内でのロールごとなどで<br />
            活動の記録を振り返ることができます。<br />
            複数のチームに所属している場合は<br />
            所属チームごとに活動を記録できます。<br />  
                </p>

          </div>
        </div>
    
     </div>

     </>
  );
};

export default Shukkin;
